import { render, staticRenderFns } from "./calendarpage.vue?vue&type=template&id=d78b2162&scoped=true&"
import script from "./calendarpage.vue?vue&type=script&lang=js&"
export * from "./calendarpage.vue?vue&type=script&lang=js&"
import style0 from "./calendarpage.vue?vue&type=style&index=0&id=d78b2162&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78b2162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d78b2162')) {
      api.createRecord('d78b2162', component.options)
    } else {
      api.reload('d78b2162', component.options)
    }
    module.hot.accept("./calendarpage.vue?vue&type=template&id=d78b2162&scoped=true&", function () {
      api.rerender('d78b2162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendarPage/calendarpage.vue"
export default component.exports